export const SET_PHOTOS = (state, photos) => {
    state.photos = photos
}

export const SET_SPECIE = (state, specie) => {
    state.specie = specie
}

export const SET_VOYAGES = (state, voyages) => {
    state.voyages = voyages
}

export const CHANGE_FULLSCREEN = (state) => {
    state.fullScreen = !state.fullScreen
}

export const SET_CAROUSELTRAVEL = (state, photos) => {
    state.carouselTravel = photos
}
export const SET_CAROUSELPORT = (state, photos) => {
    state.carouselPort = photos
}
export const SET_CAROUSELRECENT = (state, photos) => {
    state.carouselRecent = photos
}